import { lazy } from 'react';
import { Outlet, Route } from 'react-router-dom';

import { AreaName } from 'domain/constants';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';
import Authorize from 'main/auth/Authorize';

import LazyRouteElement from './common/LazyRoute';

const MaintenancePlannerPage = lazy(
	() => import('pages/maintenanceplanner/MaintenancePlannerPage')
);

const MaintenancePlannerSearchPage = lazy(
	() => import('pages/maintenanceplanner/MaintenancePlannerSearchPage')
);

export const getMaintenancePlannerRoutes = (): React.JSX.Element[] => [
	<Route
		key={'MaintenancePlanner'}
		path={''}
		element={
			<Authorize
				area={createArea(
					AreaName.MaintenancePlanner,
					OperationType.Read
				)}>
				<Outlet />
			</Authorize>
		}>
		<Route
			index
			element={
				<LazyRouteElement
					Component={MaintenancePlannerPage}
					path={'MaintenancePlanner'}
				/>
			}
		/>
		<Route
			path={'SearchPage'}
			element={
				<LazyRouteElement
					Component={MaintenancePlannerSearchPage}
					path={'SearchPage'}
				/>
			}
		/>
	</Route>,
];
